import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadComponent } from './upload.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import {EmmaTooltipModule} from '../../base-components/emma-tooltip/emma-tooltip.module';

@NgModule({
  declarations: [
    UploadComponent,
  ],
  imports: [
    CommonModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    EmmaTooltipModule,
  ],
  exports: [
    UploadComponent,
  ],
})
export class UploadModule { }
